<div class="contact-page modal">
    <form [formGroup]="facturacionForm" class="theme-form" (keydown.enter)="$event.preventDefault()" autocomplete="off">
        <div class="container d-flex justify-content-center">
            <div class="col-10 p-5 modal-body">
                <div class="col-sm-12">
                    <h3>Registrar Datos para facturar</h3>
                    <div class="row">
                        <!-- <div class="col-12 mb-3">
                                <label for="rfc">Referencia de información:</label>
                                <input  type="text" (input)="soloLetrasNumerosEspacios($event)" class="form-control text-uppercase"  formControlName="rfc" id="rfc" required="" maxlength="12" placeholder="Facturación Número 1">
                                <span class="text-danger"
                                    *ngIf="(facturacionForm.get('rfc').touched) && facturacionForm.get('rfc').errors?.required">
                                    Campo requerido
                                </span>
                            </div> -->
                        <div class="col-md-6 mb-3">
                            <label for="rfc">Clave del Registro Federal de Contribuyentes (RFC)</label>
                            <input type="text" (input)="soloLetrasNumerosExt($event)"
                                class="form-control text-uppercase mb-0" formControlName="rfc" id="rfc" required=""
                                maxlength="12" placeholder="Ingresa el RFC">
                            <span class="text-danger"
                                *ngIf="(facturacionForm.get('rfc').touched) && facturacionForm.get('rfc').errors?.required">
                                Campo requerido
                            </span>
                            <span class="text-danger" *ngIf="(facturacionForm.get('rfc').errors?.pattern)">
                                El campo debe contener letras y números
                            </span>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="nombre"> Nombre, denominación o razón social</label>
                            <input type="text" formControlName="nombre" class="form-control mb-0" id="nombre" required>
                            <span class="text-danger"
                                *ngIf="(facturacionForm.get('nombre').touched) && facturacionForm.get('nombre').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="domicilioFiscal">Código Postal del domicilio fiscal</label>
                            <input type="text" formControlName="cp" class="form-control mb-0" id="domicilioFiscal" required
                                (input)="soloNumerosDomFisc($event)" maxlength="5">
                            <span class="text-danger"
                                *ngIf="(facturacionForm.get('cp').touched) && facturacionForm.get('cp').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="regimenFiscal">Régimen Fiscal</label>
                            <select formControlName="regimenFiscal" class="form-control" id="usoCfdi"
                                (change)="changeCdfi()" required [compareWith]="compareRf">
                                <option style="text-overflow: ellipsis !important" value="" selected [disabled]="true">
                                    Seleccione</option>
                                <option *ngFor="let cfdi of listaCfdi; index as i" [ngValue]="cfdi">
                                    {{cfdi.usoCFDI}} - {{cfdi.descripcion}}
                                </option>
                            </select>
                            <span class="text-danger"
                                *ngIf="(facturacionForm.get('usoCfdi').touched) && facturacionForm.get('usoCfdi').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                        <div class="col-md-12 mb-5">
                            <label id="usoCfdi">Uso CFDI</label>
                            <select formControlName="usoCfdi" class="form-control" id="usoCfdi" (change)="changeCdfi()"
                                required>
                                <option style="text-overflow: ellipsis !important" value="" selected [disabled]="true">
                                    Seleccione</option>
                                <option *ngFor="let cfdi of listaCfdi; index as i" [ngValue]="cfdi">
                                    {{cfdi.usoCFDI}} - {{cfdi.descripcion}}
                                </option>
                            </select>
                            <span class="text-danger"
                                *ngIf="(facturacionForm.get('usoCfdi').touched) && facturacionForm.get('usoCfdi').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4 d-flex justify-content-center align-items-center gap-3">
                        <button class="btn btn-solid" (click)="guardar()" id="guardarBoton" >
                            <span>Guardar</span>
                        </button>&nbsp;
                        <button class="btn btn-solid" (click)="closeModal(false)" id="guardarBoton" >
                            <span>Cancelar</span>
                        </button>&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>